import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import LoadingButton from "src/components/Buttons/LoadingButton";
import CheckIcon from "@mui/icons-material/Check";
import { useTranslation } from "react-i18next";
import { useIsMobile } from "src/hooks/useIsMobile";
import { useMemo } from "react";
import { usePatient } from "src/context/PatientProvider";
import { useProduct } from "src/context/ProductProvider";

interface Props {
  deleteFile: () => void;
  loading: boolean;
  onConfirm: () => void;
  type: string;
}

const IdConfirmation = ({ deleteFile, loading, onConfirm, type }: Props) => {
  const page = "identity-verification";
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const paConsent = usePatient((p) => p.prior_auth_consent);
  const insuranceBased = useProduct((product) => product.insurance_based);

  const reviewImageChecks = useMemo(
    () => [
      `${page}.confirmation.checks_${type}.0`,
      `${page}.confirmation.checks_${type}.1`,
      `${page}.confirmation.checks_${type}.2`,
      `${page}.confirmation.checks_${type}.3`,
      `${page}.confirmation.checks_${type}.4`,
    ],

    [type],
  );

  return (
    <>
      <Stack gap={1}>
        {type !== "insurance"
          ? reviewImageChecks.map((check, idx) => (
              <Box key={idx} display="flex" gap={1} alignItems="center">
                <CheckIcon sx={{ color: "#00B6B9" }} />
                <Typography variant={isMobile ? "subtitle2" : "subtitle1"}>
                  {t(check)}
                </Typography>
              </Box>
            ))
          : null}
      </Stack>
      <Stack
        mt={3}
        alignItems="center"
        gap={3}
        direction={isMobile ? "column" : "row"}
      >
        <LoadingButton
          loading={loading}
          fullWidth
          onClick={onConfirm}
          disabled={insuranceBased && !paConsent}
        >
          {t(`button.confirm`, "Confirm")}
        </LoadingButton>
        <Button variant="secondary" fullWidth onClick={deleteFile}>
          {t(`button.retake`, "Retake")}
        </Button>
      </Stack>
    </>
  );
};

export default IdConfirmation;
